<template>
  <div class="outer">
      <div class="header">
          <span>{{list[data.id-1].define}}</span>
          <div>
                <i class="el-icon-circle-plus-outline" @click="add"></i>
                <i class="el-icon-remove-outline" @click="deletedata" v-if="len>1"></i>
          </div>
      </div>
      <div :class="data.data.length>1?'container multi':'container'">
        <div class="condition" v-if="data.data.length>1" @click="changeMode">{{data.type==0?$t('message.且'):$t('message.或')}}</div>
        <div v-for="(item,index) in data.data" :key='JSON.stringify(item)'>
            <!-- <div class="header2">test...</div> -->
            <children :class="index%2==0?' otherc choose1':'choose1' " 
            :databasetype='databasetype' :style="index==data.data.length-1?'margin-bottom:0':''" :count='data.data' :index='index' :id='item.id' 
            @delete='removechild' 
            @addchlid='addchlid' 
            @deletechild='deletechild' 
            @changechildmode='changechildmode'></children>
        </div>
      </div>
  </div>
</template>

<script>
import children from '@/components/children/children.vue'
  import userTableType from '@/utils/UserTableType'

export default {
    name:'test',
    components:{
        children
    },
    props:['data','len','index1','databasetype'],
    data(){
        return{
            dataref:{
                // 控制且或
                type:0,
                count:[{id:0,data:{
                    type:0,
                    children:[]
                }}]
            },
            list:userTableType.getData()
        }
    },
    methods:{
        add(){
            this.data.data.push({id:this.data.data[this.data.data.length-1].id+1,data:{type:0,children:[]},rules:{act:'',opeation:'',limit:[]}})
        },
        removechild(index){
            this.data.data.splice(index,1)
        },
        addchlid(index){
            this.data.data[index].data.children.push({pid:this.data.data[index].id,rules:{act:'',opeation:'',limit:[]},id:this.data.data[index].data.children.length>0?this.data.data[index].data.children[this.data.data[index].data.children.length-1].id+1:0})
            console.log(index);
        },
        deletechild(index,indexf){
            this.data.data[indexf].data.children.splice(index,1)
        },
        changeMode(){
            if(this.data.type==0){
                this.data.type=1
            }else{
                this.data.type=0
            }
        },
        changechildmode(index){
            if(this.data.data[index].data.type==0){
                this.data.data[index].data.type=1
            }else{
                this.data.data[index].data.type=0
            }
            
        },
        deletedata(){
            this.$emit('deletedata',this.index1)
        }
    },
    mounted(){
        console.log(this.databasetype);
    }
}
</script>

<style scoped>
.outer{
    border: 1px solid rgba(238, 228, 228, 0.4);
    background-color: rgb(255, 255, 255);
    margin-left: 20px;
    margin-bottom: 20px;
    padding-top:0 ;
    padding-bottom:10px ;
    width: 90%;
}
.header{
    display: flex;
    justify-content: space-between;
    height: 30px;
    font-size: 18px;
    padding: 6px 20px 6px 20px;
    background-color: #FAFAFA;
}
.el-icon-circle-plus-outline{
    color: greenyellow;
    cursor: pointer;
}
.el-icon-circle-plus-outline:active{
    color: blue;
}
.container{
    margin: 10px 0 10px 15px;
    position: relative;
}
.header2{
    display: flex;
    justify-content: space-between;
    height: 30px;
    font-size: 18px;
    margin: 0 0 0 30px;
    padding: 6px 20px 6px 20px;
    background-color: #FAFAFA;
}
    .choose1{
        /* height: 60px; */
        width: calc(100%-30px);
        /* display: flex; */
        justify-content: space-between;
        font-size: 18px;
        padding: 10px 40px 10px 15px;
        margin: 0 0 15px 30px;
        background-color: #F2FCFA;
    }
    .otherc{
        background-color: #ECF5FB;
    }
    .multi{
        border-left: 1px solid #ccc;
    }
    .multi::before{
        content: '';
        display: block;
        height: 1px;
        width: 20px;
        background-color: #ccc;
    }
    .multi::after{
        content: '';
        display: block;
        width: 20px;
        height: 1px;
        background-color: #ccc;
    }
    .last{
        margin-bottom: none;
    }
    .condition{
        position: absolute;
        padding: 3px;
        background-color: #0cc4a9;
        color: #fff;
        font-weight: 700;
        border-radius: 3px;
        top: 50%;
        cursor: pointer;
        left: 0;
        transform: translate(-50%,-50%);
    }
</style>


// WEBPACK FOOTER //
// src/pages/test/test.vue